import { useContext } from 'react';
import { PeriodChartsDataContext } from '../contexts/PeriodChartsDataContext';

export const usePeriodChartsDataContext = () => {
    return useContext(PeriodChartsDataContext);
};
